import React, {useEffect, useState} from "react";

import moment from 'moment';
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import {Line} from "react-chartjs-2";
import HttpRequest from "../../services/HttpRequest";
import NodeSelector from "../../gateways/component/NodeSelector";
import {dayMonthYearAtTime, getDaysAgo, getEndDate, getMinutesAgo, HourMinute} from "../../utils/dates";
import {Col, Row} from "react-bootstrap";
import {DateRangeSelector} from "../../component/Date/DateRangeSelector";
import {InputWithLabel} from "../../component/Form/InputWithLabel";

const AlertsChartPage = () => {

  const [nodes, setNodes] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [customFilter, setCustomFilter] = useState(
    {
      startDate: getMinutesAgo(10),
      endDate: moment(new Date()),
    })


  const chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 1
        },
      }]
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Pings por Minuto',
      },
    },
  };

  const intToRGB = (value) => {
    let blue = Math.floor(value % 256);
    let green = Math.floor(value / 256 % 256);
    let red = Math.floor(value / 256 / 256 % 256);
    return {blue, green, red};
  }

  const handleDateRangeSelect = (startDate, endDate) => {

    const oldTimeStar = customFilter.startDate;
    const oldTimeEnd = customFilter.endDate;

    const customFilterNew = {startDate: moment(startDate), endDate: moment(endDate)};

    setTime(HourMinute(oldTimeStar), customFilterNew.startDate, 0, 0);
    setTime(HourMinute(oldTimeEnd), customFilterNew.endDate, 59, 59);

    setCustomFilter({...customFilterNew});
  }

  function setTime(value, moment, second, millisecond) {
    const time = value.split(':');
    moment.set('hour', time[0]);
    moment.set('minute', time[1]);
    moment.set('second', second);
    moment.set('millisecond', millisecond);
  }

  const handleStartTime = (e) => {
    const startDate = customFilter.startDate;
    setTime(e.target.value, startDate, 0, 0);
    const endDate = customFilter.endDate;
    setTime(e.target.value , endDate, 659, 999)
    setCustomFilter({...customFilter})
  }
  const mapData = (data) => {

    const chartData = {
      labels: new Set(),
      datasets: [],
    }

    const nodeByMac = {};
    data.forEach(x => {
      chartData.labels.add(x.time);
      nodeByMac[x.nodeMac] = {label: x.nodeMac, data: []};
    });

    chartData.labels.forEach(time => {
      Object.keys(nodeByMac).forEach(nodeMac => {
        const node = nodeByMac[nodeMac];
        const nodeData = data.find(y => y.nodeMac === nodeMac && y.time === time);
        let valueData = 0;
        if (nodeData) {
          valueData = nodeData.total;
        }
        node.data.push(valueData);
      })

    });

    Object.keys(nodeByMac).forEach(nodeMac => {
      const node = nodeByMac[nodeMac];

      const color = intToRGB(parseInt(nodeMac, 16));

      chartData.datasets.push(
        {
          label: nodeMac,
          data: node.data,
          fill: true,
          borderColor: 'rgb(' + color.blue + ', ' + color.green + ', ' + color.red
            + ')',
          backgroundColor: 'rgb(' + color.blue + ', ' + color.green + ', '
            + color.red + ', 0.5)',
        }
      );
    });

    chartData.labels = [...chartData.labels].map(x => dayMonthYearAtTime(x));
    setChartData(chartData);
  }

  const loadData = async () => {

    const nodeMacs = nodes.map(x => x.uuid).join(',');

    const chartData = await new HttpRequest().get(
      `cloud/v1/nodes/ping/summary?startDate=${customFilter.startDate.toISOString()}&endDate=${customFilter.endDate.toISOString()}&nodeMacs=${nodeMacs}`)

    mapData(chartData);
  }

  useEffect(() => {
    loadData()
  }, [nodes, customFilter])

  return (
    <Page title="Pings por Minuto">
      <Row>
        <Col sm={4}>
          <NodeSelector multiple onChange={node => setNodes(node)}/>
        </Col>
        <Col sm={4}>
          <DateRangeSelector defaultStartDate={customFilter.startDate}
                             onChange={handleDateRangeSelect}/>
        </Col>
        <Col sm={2}>
          <InputWithLabel
            defaultValue={HourMinute(customFilter.startDate)}
            label="Horário início"
            inputType="time"
            onChange={handleStartTime}
          />
        </Col>
        <Col sm={2}>
          <InputWithLabel
            label="Horário fim"
            inputType="time"
            disabled
            defaultValue={HourMinute(customFilter.endDate)}
            value={HourMinute(customFilter.endDate)}
          />
        </Col>
      </Row>
      <Box info>
        <Line options={chartOptions} data={chartData}/>
      </Box>
    </Page>
  );
}

export default AlertsChartPage;



// WEBPACK FOOTER //
// ./src/pages/Alerts/AlertsChartPage.js